// src/components/layout/Topbar.js
import React from 'react';
import { useApp } from '../../contexts/AppContext';
import { useTheme } from '../../contexts/ThemeContext';

const PAGE_TITLES = {
  dashboard: 'Dashboard', users: 'User Management', clients: 'Client Management',
  trucks: 'Truck Management', gps: 'GPS Devices', gpsLoads: 'SIM Load Monitor', documents: 'Documents',
  tracking: 'Live Tracking', geofencing: 'Geofencing', history: 'Travel History', reports: 'Reports',
  my_trucks: 'My Fleet', live_map: 'Live Map', settings: 'Settings',
};

export default function Topbar({ activePage, isMobile, onOpenMenu }) {
  const { currentUser, notification } = useApp();
  const { theme } = useTheme();
  const now = new Date().toLocaleDateString('en-PH', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });

  return (
    <>
      <header style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: isMobile ? '12px 14px' : '14px 28px',
        background: theme.bgSidebar, borderBottom: `1px solid ${theme.border}`, flexShrink: 0,
        gap: 10,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 10 : 14, minWidth: 0 }}>
          {isMobile && (
            <button
              onClick={onOpenMenu}
              aria-label="Open menu"
              style={{
                width: 36, height: 36, flexShrink: 0, background: theme.bgHover,
                border: `1px solid ${theme.border}`, borderRadius: 9, color: theme.textPrimary,
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M3 6h18M3 12h18M3 18h18" />
              </svg>
            </button>
          )}
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 14, minWidth: 0, overflow: 'hidden' }}>
            <h2 style={{
              fontFamily: 'Syne, sans-serif', fontWeight: 700,
              fontSize: isMobile ? 16 : 20, color: theme.textPrimary, letterSpacing: '-0.3px',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>
              {PAGE_TITLES[activePage] || activePage}
            </h2>
            {!isMobile && <span style={{ fontSize: 12, color: theme.textFaint, whiteSpace: 'nowrap' }}>{now}</span>}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 8 : 14, flexShrink: 0 }}>
          {!isMobile && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#34d399', background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)', padding: '4px 10px', borderRadius: 20 }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#34d399', boxShadow: '0 0 6px #34d399', display: 'inline-block' }} />
              Online
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 0 : 8, padding: isMobile ? 0 : '5px 12px', background: isMobile ? 'transparent' : theme.bgHover, border: isMobile ? 'none' : `1px solid ${theme.border}`, borderRadius: 20 }}>
            <span style={{ width: isMobile ? 32 : 24, height: isMobile ? 32 : 24, borderRadius: isMobile ? 9 : 6, background: 'rgba(249,115,22,0.2)', color: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: isMobile ? 12 : 10, fontWeight: 700, fontFamily: 'Syne, sans-serif', flexShrink: 0 }}>
              {currentUser?.avatar}
            </span>
            {!isMobile && <span style={{ fontSize: 12, fontWeight: 500, color: theme.textSecondary }}>{currentUser?.name?.split(' ')[0]}</span>}
          </div>
        </div>
      </header>

      {notification && (
        <div style={{
          position: 'fixed',
          top: isMobile ? 'auto' : 20,
          bottom: isMobile ? 16 : 'auto',
          right: isMobile ? 12 : 20,
          left: isMobile ? 12 : 'auto',
          zIndex: 9999,
          padding: '11px 18px', borderRadius: 10, border: '1px solid',
          fontSize: 13, fontWeight: 500, backdropFilter: 'blur(10px)',
          animation: isMobile ? 'fadeIn 0.3s ease' : 'slideIn 0.3s ease',
          maxWidth: isMobile ? 'none' : 380,
          background: notification.type === 'success' ? 'rgba(16,185,129,0.12)' : notification.type === 'info' ? 'rgba(59,130,246,0.12)' : 'rgba(239,68,68,0.12)',
          borderColor: notification.type === 'success' ? 'rgba(16,185,129,0.3)' : notification.type === 'info' ? 'rgba(59,130,246,0.3)' : 'rgba(239,68,68,0.3)',
          color: notification.type === 'success' ? '#34d399' : notification.type === 'info' ? '#60a5fa' : '#f87171',
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        }}>
          {notification.type === 'success' ? '✓' : notification.type === 'info' ? 'ℹ' : '⚠'} {notification.message}
        </div>
      )}
    </>
  );
}
